import axios from 'axios';

export const sendContact = async (data: { name: string; email: string; message: string }) => {
  const res = await axios.post('/contact', data);
  return res.data;
};
